import { useState } from 'react'

import { each, pickBy, reduce } from 'lodash'

export const useMultiSelect = () => {
  const [selected, setSelected] = useState<{ [key: string]: boolean }>({})

  const select = (id: string, select: boolean = true) => {
    setSelected(pickBy({ ...selected, [id]: select }, (s) => s))
  }

  const isSelected = (id: string) => {
    return selected[id] || false
  }

  const setSelectedIds = (ids: string[]) => {
    const newSelected = reduce(
      ids,
      (prev, id) => {
        return { ...prev, [id]: true }
      },
      {} as { [key: string]: boolean },
    )
    setSelected(newSelected)
  }

  const getSelectedIds = () => {
    return Object.keys(selected)
  }

  const isAllSelected = (ids: string[]) => {
    let allSelected = true
    each(ids, (id) => {
      if (!selected[id]) {
        allSelected = false
      }
    })
    return allSelected
  }

  const isSomeSelected = (ids: string[]) => {
    let someSelected = false
    each(ids, (id) => {
      if (selected[id]) {
        someSelected = true
      }
    })
    return someSelected
  }

  return {
    select,
    isSelected,
    setSelectedIds,
    getSelectedIds,
    isAllSelected,
    isSomeSelected,
  }
}
